import SagaDuck from '@duckness/saga'
import { duckName } from './constants'
import { WELCOME_ACTIONS, type WelcomeActionType } from './WelcomeDuck.actions'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import type { WelcomeMessageContentType } from '@aytm/app/insights/dashboard/components/blocks/WelcomeOverlay/types'
import { take, select, put, type TakeEffect, type PutEffect, type SelectEffect } from 'redux-saga/effects'
import { welcomeMessageContent } from '@aytm/app/insights/dashboard/duckness/ducks/WelcomeDuck/welcomeMessageContent'

type WelcomeDuckSelectorsType = {
  welcomeMessage: (state: InsightsDashboardPoolState) => InsightsDashboardPoolState['welcomeMessage']
}

export const WelcomeDuck = SagaDuck<InsightsDashboardPoolState, WelcomeActionType, WelcomeDuckSelectorsType>(
  duckName,
  'insights-dashboard'
)

// actions
WelcomeDuck.action(WELCOME_ACTIONS.SET_WELCOME_MESSAGE)
WelcomeDuck.action(WELCOME_ACTIONS.DISMISS_WELCOME_MESSAGE)

// selectors
WelcomeDuck.selector('welcomeMessage', state => state.welcomeMessage)

// reducers
WelcomeDuck.reducer<WelcomeMessageContentType>(WELCOME_ACTIONS.SET_WELCOME_MESSAGE, (state, action) => {
  return {
    ...state,
    isNewSchemaVersionDetected: false, // TODO: later on, decouple this flag from welcome message
    welcomeMessage: action.payload
  }
})

WelcomeDuck.reducer<void>(WELCOME_ACTIONS.DISMISS_WELCOME_MESSAGE, state => {
  return {
    ...state,
    welcomeMessage: null
  }
})

WelcomeDuck.saga(function* init(duckFace): Generator<TakeEffect | PutEffect | SelectEffect, void, boolean> {
  yield take(duckFace.mapActionType('@@INIT'))
  const isNewSchemaVersionDetected = yield select(
    (state: InsightsDashboardPoolState) => state.isNewSchemaVersionDetected
  )
  yield put(
    duckFace.action[WELCOME_ACTIONS.SET_WELCOME_MESSAGE](isNewSchemaVersionDetected ? welcomeMessageContent : null)
  )
})

export default WelcomeDuck
